'use strict'

import React from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }
  componentDidCatch (error, info) {
    console.log(error)
    this.setState({ hasError: true })
  }
  render () {
    if (this.state.hasError) {
      return (
        <div id='helpfaq' className='faq page container errorboundary'>
          <div id='helpfaqcontent' tabIndex='-1' />
          <div className='container ask-tpl-container'>
            <h2 className='page__title'>Something went wrong!</h2>
            <p className='page__content'>This page seems to be broken, please try again later.</p>
            <p>
              <a href='/help/' className='faq__button' data-el='btn-back-to-help-home'>
                <span className='argos-icon icon-UIE-Controls-Chevron-Left' aria-hidden='true' />
                Back to help home
              </a>
            </p>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.object
}

export default ErrorBoundary
